import { SeuLocalStorageKey, SeuTableId } from '@seu-types';
import { neverError } from './never.helper';

export function getTablePageSizeStorageKey(
  tableId: SeuTableId
): SeuLocalStorageKey {
  switch (tableId) {
    case 'offer':
      return 'table-offer-items-per-page';
    default:
      neverError(tableId);
  }
}
